(() => {
  const initStory = (root) => {
    if (root.dataset.yspReady === 'true') return;
    root.dataset.yspReady = 'true';
    root.classList.add('is-enhanced');

    const timeline = root.querySelector('[data-ysp-timeline]');
    if (timeline) {
      const milestones = Array.from(timeline.querySelectorAll('[data-ysp-milestone]'));

      const activateMilestone = (index) => {
        milestones.forEach((milestone, itemIndex) => {
          milestone.classList.toggle('is-active', itemIndex <= index);
        });

        const denominator = Math.max(milestones.length - 1, 1);
        const progress = milestones.length === 1 ? 100 : (index / denominator) * 100;
        timeline.style.setProperty('--ysp-progress', `${Math.max(0, Math.min(progress, 100))}%`);
      };

      activateMilestone(0);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              activateMilestone(Number(entry.target.dataset.index || 0));
            }
          });
        }, {
          rootMargin: '-34% 0px -46% 0px',
          threshold: 0
        });

        milestones.forEach((milestone) => observer.observe(milestone));
      } else {
        activateMilestone(milestones.length - 1);
      }
    }

    const proof = root.querySelector('[data-ysp-proof]');
    if (proof) {
      const buttons = Array.from(proof.querySelectorAll('[data-ysp-hotspot]'));
      const details = Array.from(proof.querySelectorAll('[data-ysp-detail]'));

      const activateHotspot = (id) => {
        buttons.forEach((button) => {
          button.setAttribute('aria-expanded', String(button.dataset.yspHotspot === id));
        });
        details.forEach((detail) => {
          detail.classList.toggle('is-active', detail.dataset.yspDetail === id);
        });
      };

      if (buttons.length > 0) {
        activateHotspot(buttons[0].dataset.yspHotspot);
      }

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activateHotspot(button.dataset.yspHotspot));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
          const nextIndex = (index + direction + buttons.length) % buttons.length;
          buttons[nextIndex].focus();
          activateHotspot(buttons[nextIndex].dataset.yspHotspot);
        });
      });
    }
  };

  const initAllStories = (scope = document) => {
    scope.querySelectorAll('[data-yoseen-story]').forEach(initStory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllStories(), { once: true });
  } else {
    initAllStories();
  }

  document.addEventListener('shopify:section:load', (event) => initAllStories(event.target));
})();
